import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import "./outputTable.scss";
import {
  Box,
  Dialog,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Divider,
  Paper,
  Popper,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { action } from "../../constants/action";
import ExcelOutput from "../../pages/administrator/ExcelOutPut";
// import { useSelector } from "react-redux";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TaskAltTwoToneIcon from "@mui/icons-material/TaskAltTwoTone";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { adminRoutes } from "../../routes/routeConstants";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Label from "../Label/Label";

const Tables = (props) => {
  const { data, handleRefresh } = props;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [data1, setData1] = useState("");
  const [preview, setPreview] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setdialogData] = useState({});
  // const [message, setMessage] = useState("");
  // const [success, setSuccess] = useState(false);
  // const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  const handleClick = (event, list) => {
    setPreview(list);
    setAnchorEl(event.currentTarget);
    setData1(list?.id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setdialogData({});
    handleRefresh();
  };
  const showPreviewDetails = () => {
    setOpenDialog(true);
    setdialogData(preview);
    setAnchorEl(null);
  };

  const PreviewDataPointCalculation = () => {
    // navigate("/data-point-calculation", {
    //   state: { id: data1 },
    // });
    navigate(`/${adminRoutes.dataPointCalculation}`, {
      state: { id: data1 },
    });
  };

  const handlePopoverOpen = (event, row) => {
    setAnchorEl2(event.currentTarget);
    setHoveredRow(row);
  };

  const handlePopoverClose = () => {
    setAnchorEl2(null);
    setHoveredRow(null);
  };
  const open2 = Boolean(anchorEl2);

  return (
    <Box className="outputTable-container ">
      <Box className="dashboard-wrap-table">
        <TableContainer className="table-container h-100">
          <Table
            stickyHeader
            className="table-output"
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell align="center" className="index-cell">
                  Index
                </TableCell>

                <TableCell align="left">Project Name</TableCell>

                <TableCell align="left">Batch Name</TableCell>
                <TableCell align="left">File Name</TableCell>

                <TableCell align="left">Status</TableCell>

                <TableCell align="left">Created Date</TableCell>

                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((list, index) => {
                return (
                  <>
                    <TableRow key={list.id}>
                      <TableCell align="center"> {index + 1}</TableCell>

                      <TableCell align="left">{list.project_name}</TableCell>

                      <TableCell align="left">{list.batch_name}</TableCell>

                      <TableCell align="left">{list.file_name}</TableCell>

                      {list.rejected === true ? (
                        <TableCell>
                          <Tooltip arrow title="Rejected">
                            <HighlightOffRoundedIcon color="error" />
                          </Tooltip>
                        </TableCell>
                      ) : (
                        <TableCell align="left">
                          {list.status ? (
                            <Tooltip arrow title="Approved">
                              <TaskAltTwoToneIcon color="success" />
                            </Tooltip>
                          ) : (
                            <Tooltip arrow title="Pending">
                              <HourglassEmptyIcon color="action" />
                            </Tooltip>
                          )}
                        </TableCell>
                      )}

                      <TableCell>{list.created_date}</TableCell>

                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: 0.5,
                            minWidth: 80, // keeps alignment consistent
                          }}
                        >
                          {list.is_merged ? (
                            <>
                              <IconButton
                                size="small"
                                onMouseEnter={(e) => handlePopoverOpen(e, list)}
                                onMouseLeave={handlePopoverClose}
                              >
                                <InfoOutlinedIcon />
                              </IconButton>

                              <Popper
                                open={open2}
                                anchorEl={anchorEl2}
                                placement="right-start"
                                sx={{ zIndex: 1300 }}
                              >
                                <Box sx={{ position: "relative", p: 1 }}>
                                  <Paper
                                    elevation={1}
                                    sx={{
                                      p: 2,
                                      minWidth: 280,
                                      boxShadow:
                                        "0px 2px 6px rgba(94, 94, 94, 0.1)",
                                    }}
                                  >
                                    <Label
                                      text="Merged Information"
                                      fontWeight={600}
                                    />
                                    <Divider sx={{ mb: 1 }} />

                                    <Box sx={{ display: "flex", gap: 1 }}>
                                      <Label
                                        text="Files Used:"
                                        fontWeight={600}
                                        sx={{ minWidth: 90 }}
                                      />

                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: 0.5,
                                        }}
                                      >
                                        {hoveredRow?.merged_files_list?.length >
                                        0 ? (
                                          hoveredRow.merged_files_list.map(
                                            (file, idx) => (
                                              <Label
                                                key={idx}
                                                text={`• ${file}`}
                                              />
                                            ),
                                          )
                                        ) : (
                                          <Label text="-" />
                                        )}
                                      </Box>
                                    </Box>
                                  </Paper>
                                </Box>
                              </Popper>
                            </>
                          ) : (
                            <Box sx={{ width: 40 }} />
                          )}

                          <IconButton onClick={(e) => handleClick(e, list)}>
                            <MoreVertIcon />
                          </IconButton>
                        </Box>

                        <Menu
                          className="action-list"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                        >
                          <MenuItem
                            className="action-item"
                            onClick={PreviewDataPointCalculation}
                          >
                            {action.DPCALCULATION}
                          </MenuItem>

                          <MenuItem
                            className="action-item"
                            onClick={showPreviewDetails}
                          >
                            Preview
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )} */}
        {openDialog && (
          <Dialog
            fullScreen
            open={openDialog}
            onClose={handleDialogClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            closeAfterTransition
          >
            <ExcelOutput
              dialogData={dialogData}
              handleDialogClose={handleDialogClose}
            />
          </Dialog>
        )}
      </Box>
    </Box>
  );
};
export default Tables;
